/**
 * Enum loại chi tiêu dự phòng
 */
export default {
  Regular: 1, // Chi thường xuyên 
  Invest: 2, // Chi đầu tư
  PreviousYearReserve: 3 // Dự toán dự phòng năm trước
}
